import GameUserComponent from '@components/game-user';
import * as React from 'react';

export interface IGameUserProps {}

export default function GameUser(props: IGameUserProps) {
  return <GameUserComponent />;
}
